// import { useContext, useState} from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";

let myAbilities = HelpAbility();

function ItemModal({i, cliente: client, vinculedClient}) {
    const {name, numDocument, /*id*/} = client;

    const handleVinculedClient = () => {
        vinculedClient({cliente: client});
    }
    return (
        <tr>
            <th className="text-center" scope="row">{i + 1}</th>
            <td className="text-center">{name}</td>
            <td className="text-center">{numDocument}</td>

            {myAbilities.hasAny([C.A.EMAIL.LINK]) && <td className="text-center d-flex">
                {myAbilities.has(C.A.EMAIL.LINK) &&

                    <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Vincular Cliente</Tooltip>}>
                        <button type="button"
                            className="btn btn-sm btn-info me-2"
                            onClick={handleVinculedClient}>
                            <i className="bi bi-person-fill" />
                        </button>
                    </OverlayTrigger>}

            </td>}
        </tr>
    )
}
export default ItemModal